module.exports = __webpack_public_path__ + "img/san-jose-hotel-5.d4c06c33.jpg";